<template>

  <el-row :gutter="5">
    <el-col :span="8"></el-col>
    <el-col :span="8"><h2 class="heading">My Expense Request List</h2></el-col>
    <el-col :span="8" style="padding-top:20px;">
        <el-button style="margin-right:10px;" @click="$router.push('/expense/allExpenseList')"
            v-if="global.hasRight('expense', 'approver') || global.hasRight('expense', 'statistician')">
            <el-icon><Search/></el-icon> &nbsp; All Expense List</el-button>
        <el-button @click="$router.push('/expense/editExpense')" title="Export as excel">
            + Add new expense request
        </el-button>
    </el-col>
  </el-row>

  <el-table :data="expenseList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="ID" width="60" align="center" sortable/>
    <el-table-column prop="title" label="Title" width="360" sortable="custom" />
    <el-table-column prop="requester" label="Requester" width="210" sortable/>
    <el-table-column prop="created" label="Request Date" align="center" width="130" sortable="custom">
        <template #default="scope">
            {{scope.row.created.toString().substring(0, 16)}}
        </template>
    </el-table-column>
    <el-table-column prop="status" label="Status" align="center" sortable="custom"/>
    <el-table-column prop="totalAmount" label="Total Amount" align="right" sortable="custom">
        <template #default="scope">
            {{global.number_format(scope.row.totalAmount, 2)}}
        </template>
    </el-table-column>
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <el-icon :size="16" v-if="scope.row.canEdit" @click="$router.push('/expense/editExpense?code=' + scope.row.idMD5)" style="cursor:pointer" title="Edit the request">
                <Edit />
            </el-icon>
            <el-icon :size="16" v-if="scope.row.canDelete" @click="deleteExpense(scope.row.idMD5)" style="cursor:pointer" title="Delete the request">
                <Delete />
            </el-icon>
            <a href="" v-if="scope.row.canApprove" @click.prevent="$router.push('/expense/viewExpense?code=' + scope.row.idMD5)" title="Approve" class="op">
                Approve
            </a>
            <el-icon :size="16" @click="$router.push('/expense/viewExpense?code=' + scope.row.idMD5)" style="cursor:pointer" title="View details">
                <document />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getExpenseList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Edit, Delete, Document, Search } from '@element-plus/icons-vue'

export default {
    components: {
        Document, Edit, Search, Delete
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            status: null,
            expenseList: [],
            page: {currPage: 1},
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "expense";
        this.getExpenseList(1);
    },
    methods: {
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.page.currPage = 1;
            this.getExpenseList(1);
        },
        async getExpenseList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            data["requester"] = this.global.currentUser.fullname;
            if (this.$route.query && this.$route.query.action)
                data["action"] = this.$route.query.action;
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }
            console.log(data);
            let result = await AXIOS("/expense/getExpenseList", data);
            if (result.success) {
                this.expenseList = result.data.expenseList;
                this.page = result.data.page;
            } else {
                this.errMsg = result.errMsg;
            }
        },
        deleteExpense(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this expense request?',  'Warning',
                { cancelButtonText: ' No ', confirmButtonText: ' Yes ', type: 'warning', }
            ).then(async () => {
                let result = await AXIOS("/expense/deleteExpense", {code: code});
                if (result.success) {
                    this.expenseList.splice(this.expenseList.findIndex(e => e.idMd5 == code), 1);
                    ElMessage({
                        message: 'Deleted expense request successfully!',
                        type: 'success',
                    });
                }
            })
        },
        tableRowClassName(scope) {
            return (scope.row.status == "Approved") ? "" : scope.row.status;
        },
        exportExpenses() {
            let requester = this.requester == null ? '' : this.requester;
            let token = encodeURIComponent(this.global.token);
            window.location.href = this.global.api_domain+"/expense/exportExpense?requester=" + requester + "&x-token=" + token;
        },
        deleteExpenses(id) {
            ElMessageBox.confirm(
                'Are you sure want to delete this expense request?',  'Warning', {
                    confirmButtonText: 'OK', cancelButtonText: 'Cancel', type: 'warning',
                }
            ).then(async () => {
                let result = await AXIOS("/expense/deleteExpense", {id : id});
                if (result.success) {
                    this.expenseList.splice(this.expenseList.findIndex(e => e.idMD5 == id), 1);
                    ElMessage({
                        message: 'Deleted expense request successfully!',
                        type: 'success',
                    });
                } else {
                    ElMessage({
                        message: result.errMsg,
                        type: 'error',
                    });
                }
            });
        }
    }
}
</script>

<style>
    .errMsg {
        padding-left:20px;
    }
    .successMsg {
        padding-left:20px;
    }
</style>